import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import LetsConnect from "./sections/LetsConnect";
import OurServiceArea from "./sections/OurServiceArea";
import InvestKcFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <LetsConnect />
      <OurServiceArea />
      <InvestKcFooter />
    </div>;
}